export default {
  coupons: [],
  productList:[],
  userList: []
}
  